/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Faq_3_QuestionInputs */

const en_svc_rag_faq_3_question = /** @type {(inputs: Svc_Rag_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is our data used to train AI models?`)
};

const lv_svc_rag_faq_3_question = /** @type {(inputs: Svc_Rag_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai mūsu dati tiek izmantoti AI modeļu apmācībai?`)
};

/**
* | output |
* | --- |
* | "Is our data used to train AI models?" |
*
* @param {Svc_Rag_Faq_3_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_faq_3_question = /** @type {((inputs?: Svc_Rag_Faq_3_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Faq_3_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_faq_3_question(inputs)
	return en_svc_rag_faq_3_question(inputs)
});